var age0 = document.getElementById('age0').getAttribute('src');
var age1 = document.getElementById('age1').getAttribute('src');
var age2 = document.getElementById('age2').getAttribute('src');
var age3 = document.getElementById('age3').getAttribute('src');
$(document).ready(function() {
	$('.trigger').click(function() {
		var tag = $(this).attr('data-filter');
		if (tag == 'all') {
			$('.all').show('1000');
		} else {
			$('.all').not('.'+tag).hide('1000');
			$('.all').filter('.'+tag).show('1000');
		}
		if (tag == 'age0') {
			document.getElementById('age0').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age0_on.jpg";
			document.getElementById('age1').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age1_off.jpg";
			document.getElementById('age2').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age2_off.jpg";
			document.getElementById('age3').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age3_off.jpg";
		}
		if (tag == 'age1') {
			document.getElementById('age0').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age0_off.jpg";
			document.getElementById('age1').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age1_on.jpg";
			document.getElementById('age2').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age2_off.jpg";
			document.getElementById('age3').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age3_off.jpg";
		}
		if (tag == 'age2') {
			document.getElementById('age0').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age0_off.jpg";
			document.getElementById('age1').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age1_off.jpg";
			document.getElementById('age2').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age2_on.jpg";
			document.getElementById('age3').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age3_off.jpg";
		}
		if (tag == 'age3') {
			document.getElementById('age0').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age0_off.jpg";
			document.getElementById('age1').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age1_off.jpg";
			document.getElementById('age2').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age2_off.jpg";
			document.getElementById('age3').src = "https://cdn.shopify.com/s/files/1/0564/0463/9883/files/age3_on.jpg";
		} 
		
		
		$(document).on('click', '.trigger', function () {
			$('.trigger').removeClass('active');
			$(this).addClass('active');
		});
	})
})